module.exports = "https://static.wmbcdn.com/uniweb/images/4a85a3b4414ddc996507eeadc2b85821.svg";